import { rj } from "react-rocketjump"
import { thresholdsApi } from "../../api"

export const ThresholdsState = rj({
  effectCaller: rj.configured(),
  effect: token => settoreAzienda => thresholdsApi(token, settoreAzienda)
})
